"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteOrderSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const combine_labels_1 = require("../../utils/combine-labels");
const meta_data_1 = require("../base/meta-data");
exports.WaysteOrderSchema = {
    name: 'wayste-order',
    alias: 'Wayste Order',
    shortName: 'Order',
    applications: ['wayste'],
    returnType: {
        wayste: transport_types_1.Order.OrderTransport,
    },
    searchableAttributes: [
        {
            field: 'serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'serviceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
        },
        {
            field: 'vendorName',
            alias: 'Vendor Name',
            shortName: 'vendor',
            searchableByDefault: true,
        },
        {
            field: 'orderNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
        },
        {
            field: 'poNumber',
            alias: 'PO Number',
            shortName: 'PO Number',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'expectedDeliveryDate',
            alias: 'Expected Delivery Date',
            shortName: 'Delivery Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            field: 'expectedPickupDate',
            alias: 'Expected Pickup Date',
            shortName: 'Pickup Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            field: 'status',
            alias: 'Order Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: (0, combine_labels_1.combineLabels)(transport_types_1.Order.OrderStatuses.map((key) => ({
                value: String(key),
                label: transport_types_1.Order.WaysteOrderStatusLabels[key],
            }))),
            allowsMultipleValues: true,
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=wayste-order.js.map